// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TL49","col":"styles_col__1p7-q"};